// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"2e2e3b2f","61":"effd5785","244":"b1516b32","294":"8753b358","356":"dab0f3b0","379":"dab0f3b0","495":"dab0f3b0","539":"9a3fbefc","670":"729f9baf"}[chunkId] + ".chunk.css";
};